/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHealthPingGet } from '../fn/health/api-health-ping-get';
import { ApiHealthPingGet$Params } from '../fn/health/api-health-ping-get';
import { Error } from '../models/error';


/**
 * Health services
 */
@Injectable({ providedIn: 'root' })
export class HealthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHealthPingGet()` */
  static readonly ApiHealthPingGetPath = '/api/health/ping';

  /**
   * Hello World / ping test endpoint.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHealthPingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthPingGet$Response(params?: ApiHealthPingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Error>> {
    return apiHealthPingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Hello World / ping test endpoint.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHealthPingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHealthPingGet(params?: ApiHealthPingGet$Params, context?: HttpContext): Observable<Error> {
    return this.apiHealthPingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Error>): Error => r.body)
    );
  }

}
